import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import { MdMoreVert, MdRemoveRedEye, MdEdit, MdDelete, MdBlock } from 'react-icons/md';
import { FaWhatsapp } from 'react-icons/fa';

export default function ActionsMenu({ item, onView, onEdit, onDelete, onWhatsapp, onBlock }) {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const handleAction = (action, event) => {
    switch (action) {
      case 'view':
        onView && onView(item);
        break;
      case 'edit':
        onEdit && onEdit(item);
        break;
      case 'delete':
        onDelete && onDelete(item, event);
        break;
      case 'whatsapp':
        onWhatsapp && onWhatsapp(item);
        break;
      case 'block':
        onBlock && onBlock(item);
        break;
      default:
        break;
    }
    handleMenuClose();
  };

  return (
    <div>
      <IconButton
        size="small"
        onClick={handleMenuOpen}
        style={{ padding: '4px' }}
      >
        <MdMoreVert size={20} style={{ color: '#122d58' }} />
      </IconButton>
      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={() => handleAction('view')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <MdRemoveRedEye size={18} style={{ color: '#122d58' }} />
          Ver detalhes
        </MenuItem>
        <MenuItem
          onClick={() => handleAction('edit')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <MdEdit size={18} style={{ color: '#4caf50' }} />
          Editar viagem
        </MenuItem>
        <MenuItem
          onClick={() => handleAction('whatsapp')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <FaWhatsapp size={16} style={{ color: '#6abf62' }} />
          WhatsApp
        </MenuItem>
        <MenuItem
          onClick={() => handleAction('block')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <MdBlock size={18} style={{ color: '#f27160' }} />
          Cancelar pagamento
        </MenuItem>
        <MenuItem
          onClick={(e) => handleAction('delete', e)}
          style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
        >
          <MdDelete size={18} style={{ color: '#f44336' }} />
          Excluir viagem
        </MenuItem>
      </Menu>
    </div>
  );
}

